import * as React from "react";

interface IBeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: "accepted" | "dismissed";
    platform: string;
  }>;
  prompt(): Promise<void>;
}

export function useAddToHomescreenPrompt(): [
  IBeforeInstallPromptEvent | null,
  () => void,
  boolean
] {
  const [prompt, setState] = React.useState<IBeforeInstallPromptEvent | null>(
    null
  );
  const [isInstalled, setIsInstalled] = React.useState<boolean>(false);

  const promptToInstall = () => {
    if (prompt) {
      console.log('SS')
      return prompt.prompt();
    }
    return Promise.reject(
      new Error(
        'Tried installing before browser sent "beforeinstallprompt" event'
      )
    );
  };

  React.useEffect(() => {
    // Check if app is already installed
    const checkIfInstalled = () => {
      // For iOS
      const isIOS = (window.navigator as any).standalone === true;
      
      // For Android and other browsers
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      
      return isIOS || isStandalone;
    };

    setIsInstalled(checkIfInstalled());

    const ready = (e: IBeforeInstallPromptEvent) => {
      e.preventDefault();
      setState(e);
    };

    const installed = () => {
      // App was just installed
      setIsInstalled(true);
      setState(null);
    };

    window.addEventListener("beforeinstallprompt", ready as any);
    window.addEventListener("appinstalled", installed as any);

    return () => {
      window.removeEventListener("beforeinstallprompt", ready as any);
      window.removeEventListener("appinstalled", installed as any);
    };
  }, []);

  return [prompt, promptToInstall, isInstalled];
}
